import { defaultLocale, isValidLocale, Locale } from '@repo/utils'
import { useIntl } from 'react-intl'

export function useLocale(): {
  locale: Locale
  defaultLocale: Locale
  localeUrlSegment: string
} {
  const { locale: intlLocale } = useIntl()
  const locale: Locale = isValidLocale(intlLocale) ? intlLocale : defaultLocale
  const localeUrlSegment = locale === defaultLocale ? '' : `/${locale}`
  return { locale, defaultLocale, localeUrlSegment }
}
